module.exports = __webpack_public_path__ + "static/img/94.cff62bc6.png";